export default __webpack_public_path__ + "static/Guides_1-aa542a9e3c043f6b9e7476e90b68d905.jpg";